import { createSlice, createAction } from "@reduxjs/toolkit";

const agentHomeSlice = createSlice({
  name: "AGENT_HOME",
  initialState: {
    recommendations: {
      agent: [],
      process: [],
    },
    interactionResponse: null,
    loading: 0,
    error: null,
    requestProcessed: false,
    requestError: false,
    activeTab: "last24Hours",
    tabStartDate: null,
    tabEndDate: null,
    agentHomeActiveAgent: "",
    // performanceData: {},
    performanceData: {
      customerSatisfaction: [
        { month: "Jan", optimal: 7.5, actual: 7.2 },
        { month: "Feb", optimal: 7.8, actual: 8.5 },
        { month: "Mar", optimal: 7.6, actual: 7.0 },
        { month: "Apr", optimal: 7.9, actual: 8.2 },
        { month: "May", optimal: 7.7, actual: 6.8 },
        { month: "Jun", optimal: 8.0, actual: 7.5 },
      ],
      firstCallResolution: [
        { month: "Jan", value: 82 },
        { month: "Feb", value: 85 },
        { month: "Mar", value: 89 },
        { month: "Apr", value: 84 },
        { month: "May", value: 86 },
        { month: "Jun", value: 83 },
      ],
      callsOnHold: [
        { month: "Jan", value: 22 },
        { month: "Feb", value: 29 },
        { month: "Mar", value: 24 },
        { month: "Apr", value: 27 },
        { month: "May", value: 23 },
        { month: "Jun", value: 25 },
      ],
      learningResources: [
        {
          id: "01",
          title: "Active Listening for Improved Customer Interactions",
          link: "#",
        },
        {
          id: "02",
          title:
            "Utilizing the Knowledge Base for Efficient Problem Resolution",
          link: "#",
        },
        {
          id: "03",
          title: "De-Escalation Techniques for Managing Upset Customers",
          link: "#",
        },
      ],
      strengthMessage:
        "Your commitment to delivering outstanding customer service shines through every interaction. Last month, your ability to listen and resolve issues effectively contributed to a 95% customer satisfaction rate. Keep up the fantastic work, as your strengths continue to pave the way for excellence.",
      inspirationalQuote:
        "Each call you take is an opportunity to shine. Your strengths continue to guide you toward excellence.",
    },
    transactionTable: {},
  },
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
      // console.log("Active Tab:", state.activeTab);
    },
    setLoading(state, action) {
      state.loading = action.payload;
      console.log(action.payload);
    },
    fetchPerformanceDataInit(state) {
      state.loading = true;
      state.requestProcessed = false;
      state.requestError = false;
    },
    fetchPerformanceDataSuccess(state, action) {
      state.loading = false;
      state.requestProcessed = true;
      state.requestError = false;
      state.performanceData = action.payload; // Update performance data here
      // console.log("Active Tab:",  state.performanceData );
      // console.log(action.payload);
    },

    setAgent(state, action) {
      state.agentHomeActiveAgent = action.payload;
    },

    fetchPerformanceDataFailure(state) {
      state.loading = false;
      state.requestProcessed = true;
      state.requestError = true;
      state.performanceData = null;
    },
    fetchRecommendationsStart(state) {
      state.loading = false;
    },
    fetchRecommendationsSuccess(state, action) {
      // state.loading = false; //! temporary fix for double loading issue
      state.recommendations = action.payload;
      // console.log("Active Tab:",  state.recommendations );
    },
    fetchRecommendationsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    // Interaction Panel actions
    fetchInteractionInit(state) {
      state.loading = true;
      state.error = null;
    },
    fetchInteractionSuccess(state, action) {
      // state.loading = false; //! temorary loading fix
      state.interactionResponse = action.payload; // Response from the API
    },
    fetchInteractionFailure(state, action) {
      state.loading = false;
      state.error = action.payload; // Error message
    },

    // fetchTransactionDetailsInit(state,action){
    //   // state.loading = true;
    //   state.error = null;
    //   console.log(action);
    // }
    fetchTransactionDetailsInit(state) {
      state.loading = true;
    },
    fetchTransactionDetailsSuccess(state, action) {
      // Corrected spelling
      state.loading = false;
      state.transactionTable = action.payload;
      // console.log("Active Tab:", state.transactionTable);
    },
    fetchTransactionDetailsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setTransactionTable(state, action) {
      state.transactionTable = action.payload;
    },
    // setRecommendation(state, action) {
    //   state.recommendations = action.payload;
    // },

    setRecommendation(state, action) {
      // ✅ Store data for agent or process separately
      if (action.payload?.agent) {
        state.recommendations.agent = action.payload.agent;
      }
      if (action.payload?.process) {
        state.recommendations.process = action.payload.process;
      }
    },
  },
});

export const {
  fetchPerformanceDataInit,
  fetchPerformanceDataSuccess,
  fetchPerformanceDataFailure,
  fetchRecommendationsStart,
  fetchRecommendationsSuccess,
  fetchRecommendationsFailure,
  setActiveTab, // Add this export
  setAgent,
  fetchInteractionInit,
  fetchInteractionSuccess,
  fetchInteractionFailure,
  setLoading,
  fetchTransactionDetailsInit,
  fetchTransactionDetailsSuccess,
  fetchTransactionDetailsFailure,
  setTransactionTable,
  setRecommendation,
} = agentHomeSlice.actions;

export default agentHomeSlice.reducer;
